import React, { useState } from 'react';
import Sidebar from './components/Sidebar';
import Navbar from './components/Navbar';
import Dashboard from './components/Dashboard';
import ProjectsBoard from './components/ProjectsBoard';
import AiStudio from './components/AiStudio';
import TeamHub from './components/TeamHub';
import TimeTracking from './components/TimeTracking';
import Settings from './components/Settings';
import NewTaskModal from './components/NewTaskModal';
import NewProjectModal from './components/NewProjectModal';
import NotificationsDrawer from './components/NotificationsDrawer';

import { 
  initialProjects, 
  initialTasks, 
  initialTeam, 
  initialWorkflows, 
  initialActivities, 
  initialTimeEntries 
} from './mockData';

export default function App() {
  const [activeTab, setActiveTab] = useState('dashboard');
  const [currentProjectId, setCurrentProjectId] = useState(initialProjects[0].id);
  
  const [projects, setProjects] = useState(initialProjects);
  const [tasks, setTasks] = useState(initialTasks);
  const [team, setTeam] = useState(initialTeam);
  const [workflows, setWorkflows] = useState(initialWorkflows);
  const [activities, setActivities] = useState(initialActivities);
  const [timeEntries, setTimeEntries] = useState(initialTimeEntries);
  const [searchQuery, setSearchQuery] = useState('');

  // Modals state
  const [showNewTaskModal, setShowNewTaskModal] = useState(false);
  const [showNewProjectModal, setShowNewProjectModal] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);

  // Handlers
  const handleAddTask = (newTask) => {
    setTasks([newTask, ...tasks]);
    setActivities([
      { id: 'act-' + Date.now(), user: 'Elena Rostova', action: 'created task', target: newTask.title, time: 'Just now', type: 'task' },
      ...activities
    ]);
  };

  const handleUpdateTask = (updatedTask) => {
    setTasks(tasks.map(t => t.id === updatedTask.id ? updatedTask : t));
  };

  const handleDeleteTask = (taskId) => {
    setTasks(tasks.filter(t => t.id !== taskId));
  };

  const handleAddProject = (newProj) => {
    setProjects([newProj, ...projects]);
    setCurrentProjectId(newProj.id);
    setActivities([
      { id: 'act-' + Date.now(), user: 'Elena Rostova', action: 'created project', target: newProj.name, time: 'Just now', type: 'project' },
      ...activities
    ]);
  };

  const handleToggleWorkflow = (wfId) => {
    setWorkflows(workflows.map(wf => wf.id === wfId ? { ...wf, active: !wf.active } : wf));
  };

  const handleAddWorkflow = (newWf) => {
    setWorkflows([newWf, ...workflows]);
  };

  const handleAddTimeEntry = (newTe) => {
    setTimeEntries([newTe, ...timeEntries]);
  };

  return (
    <div className="flex h-screen w-screen overflow-hidden bg-slate-50 font-['Inter',sans-serif]">
      
      {/* Sidebar */}
      <Sidebar 
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        projects={projects}
        currentProjectId={currentProjectId}
        setCurrentProjectId={setCurrentProjectId}
      />

      {/* Main Content Area */}
      <div className="flex-1 flex flex-col h-screen overflow-hidden">
        
        <Navbar 
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          onOpenNewTask={() => setShowNewTaskModal(true)}
          onOpenNewProject={() => setShowNewProjectModal(true)}
          onOpenNotifications={() => setShowNotifications(true)}
          unreadCount={3}
          setActiveTab={setActiveTab}
        />

        <main className="flex-1 overflow-y-auto">
          {activeTab === 'dashboard' && (
            <Dashboard 
              projects={projects}
              tasks={tasks}
              team={team}
              setActiveTab={setActiveTab}
              setCurrentProjectId={setCurrentProjectId}
              onOpenNewTask={() => setShowNewTaskModal(true)}
              onOpenNewProject={() => setShowNewProjectModal(true)}
            />
          )}

          {activeTab === 'projects' && (
            <ProjectsBoard 
              projects={projects}
              currentProjectId={currentProjectId}
              setCurrentProjectId={setCurrentProjectId}
              tasks={tasks}
              team={team}
              onAddTask={handleAddTask}
              onUpdateTask={handleUpdateTask}
              onDeleteTask={handleDeleteTask}
              onOpenNewTask={() => setShowNewTaskModal(true)}
            />
          )}

          {activeTab === 'ai' && (
            <AiStudio 
              workflows={workflows}
              onToggleWorkflow={handleToggleWorkflow}
              onAddWorkflow={handleAddWorkflow}
              projects={projects}
              team={team}
            />
          )}

          {activeTab === 'team' && (
            <TeamHub 
              team={team}
              tasks={tasks}
            />
          )}

          {activeTab === 'time' && (
            <TimeTracking 
              timeEntries={timeEntries}
              onAddTimeEntry={handleAddTimeEntry}
              projects={projects}
              team={team}
            />
          )}

          {activeTab === 'settings' && (
            <Settings />
          )}
        </main>

      </div>

      {/* Modals & Drawers */}
      {showNewTaskModal && (
        <NewTaskModal 
          projects={projects}
          currentProjectId={currentProjectId}
          team={team}
          onClose={() => setShowNewTaskModal(false)}
          onAddTask={handleAddTask}
        />
      )}

      {showNewProjectModal && (
        <NewProjectModal 
          team={team}
          onClose={() => setShowNewProjectModal(false)}
          onAddProject={handleAddProject}
        />
      )}

      {showNotifications && (
        <NotificationsDrawer 
          activities={activities}
          onClose={() => setShowNotifications(false)}
        />
      )}

    </div>
  );
}
